import topic from '../topic';

export const dataStaticsAPI = {
  getStatiTheProporSampl: topic.stat1Topic + '/getStatiTheProporSampl',
  excelStatiTheProporSampl: topic.stat1Topic + '/excelStatiTheProporSampl',
  getProcess: topic.statTopic + '/getProcess',
  getPutStorage: topic.statTopic + '/getPutStorage',
  processStatisticssh: topic.statTopic + '/processStatisticssh', 
  processStatisticsyz: topic.statTopic + '/processStatisticsyz',
  excelProcessStatistics: topic.statTopic + '/excelProcessStatistics',
  // 式样分数据查询（手裁/机缝/手工）
  getStyleScoreData: topic.statTopic + '/getStyleScoreData',
  getDiffList: topic.statTopic + '/getDiffList',
  getBasicScoreMaintenance: topic.statTopic + '/getBasicScoreMaintenance',
  getWorkPerformanceStatistics: topic.statTopic + '/getWorkPerformanceStatistics',
  getBasicgetWorkPerformanceStatistics: topic.statTopic + '/getBasicgetWorkPerformanceStatistics',
  editDiffList: topic.statTopic + '/editDiffList',
  editBasicScoreMaintenance: topic.statTopic + '/editBasicScoreMaintenance',
  editBasicgetWorkPerformanceStatistics: topic.statTopic + '/editBasicgetWorkPerformanceStatistics',
  getErrorCorrectionDetails: topic.statTopic + '/getErrorCorrectionDetails',
  getFabricStatistics: topic.statTopic + '/getFabricStatistics',
  getYzProcessStatistics: topic.statTopic + '/getYzProcessStatistics'
};
